import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const MODES = [
  { id: "ALL", label: "All time" },
  { id: "DATE", label: "By date" },
  { id: "MONTH", label: "By month" },
  { id: "YEAR", label: "By year" },
];

const YEARS = (() => {
  const y = new Date().getFullYear();
  return [y + 1, y, y - 1, y - 2, y - 3].map(String);
})();

/** Convert the filter value {mode,date,month,year} to {start,end} or null. */
export function expenseFilterRange(v) {
  if (v.mode === "DATE" && v.date) return { start: v.date, end: v.date };
  if (v.mode === "MONTH" && v.month) {
    const [y, m] = v.month.split("-").map(Number);
    const last = new Date(y, m, 0).getDate();
    return { start: `${v.month}-01`, end: `${v.month}-${String(last).padStart(2, "0")}` };
  }
  if (v.mode === "YEAR" && v.year) return { start: `${v.year}-01-01`, end: `${v.year}-12-31` };
  return null;
}

export function ExpenseDateFilter({ value, onChange, idPrefix = "expense-filter" }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Select value={value.mode} onValueChange={(mode) => set({ mode })}>
        <SelectTrigger className="w-[130px] h-9" data-testid={`${idPrefix}-mode`}><SelectValue /></SelectTrigger>
        <SelectContent>
          {MODES.map((m) => <SelectItem key={m.id} value={m.id}>{m.label}</SelectItem>)}
        </SelectContent>
      </Select>
      {value.mode === "DATE" && (
        <Input type="date" className="h-9 w-[150px]" value={value.date} onChange={(e) => set({ date: e.target.value })} data-testid={`${idPrefix}-date`} />
      )}
      {value.mode === "MONTH" && (
        <Input type="month" className="h-9 w-[160px]" value={value.month} onChange={(e) => set({ month: e.target.value })} data-testid={`${idPrefix}-month`} />
      )}
      {value.mode === "YEAR" && (
        <Select value={value.year} onValueChange={(year) => set({ year })}>
          <SelectTrigger className="w-[110px] h-9" data-testid={`${idPrefix}-year`}><SelectValue /></SelectTrigger>
          <SelectContent>
            {YEARS.map((y) => <SelectItem key={y} value={y}>{y}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
